window.riot = riot = require 'riot'
isEditMode = window.location.search.match(/editmode=true/)

showlogin = =>
  window.location.href = "/duocms/api/google/login"

import {component,Forum,Toaster} from "duo-kit"
component({component:Forum,tagname:"duo-forum",href:"/resources/css/site.css",shadow:isEditMode,attributes:["forumid"],defaults:{logintxt:"Login with Google",showlogin}})
component({component:Toaster,tagname:"duo-toaster",href:"/resources/css/site.css",shadow:isEditMode})

require 'riot-kit/lib/slideshow'
require 'riot-kit/lib/datepicker'
require 'riot-kit/lib/dateformat'

require "riot-kit/lib/img_loader"
require "riot-kit/lib/progressbar"
require "riot-kit/lib/confirm"
require "riot-kit/lib/modal"
# require "./tags/booking-calendar.tag"
require "riot-kit/lib/booking-calendar"
# require 'riot-kit/lib/formdate'
require './tags/navigation.tag'
require './tags/counter.tag'
require './tags/form.tag'
require 'riot-kit/lib/gmap'
require './tags/duomap.tag'
require './tags/availability-cal.tag'
require './tags/pricing.tag'
require './tags/memgraph.tag'
require './tags/stars.tag'
require './tags/ofsted.tag'
require './tags/projects.tag'
require './tags/tags-input.tag'

require './tags/chat.tag'
tns = require "./tinyslider.js"

require 'riot-kit/lib/ecommerce'

require './libs/slideshow.coffee'

riot.mount('*')
document.addEventListener 'duocms:updated', ->
  riot.mount('slideshow,gmap,buy,basket,checkout,stars')

# loads css async
[].slice.call(document.querySelectorAll("link[media=none]")).forEach (stl)-> stl.setAttribute("media","all")
[].slice.call(document.querySelectorAll('input')).forEach (input)-> 
  input.setAttribute("style","display:none") if input.getAttribute("name")?.match(/^duoreform/)

if document.querySelector ".moresites"
  slider = tns({
    container: '.moresites .row',
    items: 3,
    controls: true,
    slideBy: 'page',
    autoplay: false,
    lazyload:true,
    mouseDrag:true,
    autoplayButton: false,
    arrowKeys: true,
    fixedWidth: 360,
    edgePadding: 0,
    controlsText:["<span class='fa fa-caret-left fa-lg'></span>","<span class='fa fa-caret-right fa-lg'></span>"]
  });

if document.querySelector ".reviews"
  # reviews - build into component?
  setTimeout =>
    slider = tns({
      container: '.reviews .row',
      items: 1,
      controls: true,
      slideBy: 'page',
      autoplay: true,
      mouseDrag:true,
      autoplayTimeout:7000,
      autoplayButton: false,
      arrowKeys: true,
      autoplayText:["",""]
      edgePadding: 0,
      controlsText:["<span class='fa fa-caret-left fa-lg'></span>","<span class='fa fa-caret-right fa-lg'></span>"]
    });

if document.querySelector ".pricing_panels"
  types = ['basic','standard','premium']
  [].forEach.call document.querySelectorAll(".pricing_panels .btn"),(elem,index)->
    elem.addEventListener "click",->
      document.querySelector('[name=enquiry]').value = if elem.className.match(/primary/) then 'order' else 'demo'
      document.querySelector('[name=website_type]').value = types[Math.floor(index/2)]
      setTimeout => document.querySelector('input[name="name"]').focus()